<template>
  <div class="book">
    <div class="page left">
      <h1>地の巻―序言</h1>
      <p class="kobun block"><strong>夫、兵法と云事、武家の法也</strong></p>
      <p class="genndaibun">そもそも、兵法とは武士のための法である。</p>

      <p class="kobun block"><strong>将たるものハ、とりわき此法をおこなひ</strong></p>
      <p class="genndaibun">将軍たる者は、特にこの法を実践しなければならない。</p>

      <p class="kobun block"><strong>卒たる者も、此道を知べき事なり</strong></p>
      <p class="genndaibun">兵士であっても、この道を知るべきである。</p>

      <p class="kobun block"><strong>今世の間に、兵法の道、たしかにわきまへたると云武士なし。</strong></p>
      <p class="genndaibun">しかし、今の世の中で、兵法の道を真に理解している武士はいない。</p>

      <p class="kobun block"><strong>先、道を顕して有ハ、佛法として人をたすくる道</strong></p>
      <p class="genndaibun">そもそも、道にはいくつかの種類があり、仏法は人を救う道である。</p>

      <p class="kobun block"><strong>又、儒道として文の道を糺し、醫者と云て諸病を治する道、</strong></p>
      <p class="genndaibun">また、儒学の道は学問を正す道であり、医者は病を治す道を行う。</p>

      <p class="kobun block"><strong>或は歌道者とて和歌の道をおしへ、或ハ数寄者、弓法者、</strong></p>
      <p class="genndaibun">あるいは、歌道者は和歌の道を教え、数寄者や弓術者もそれぞれの道を極める。</p>

      <p class="kobun block"><strong>其外、諸藝諸能までも、思ひ思ひに稽古し、心々にすくもの也。</strong></p>
      <p class="genndaibun">それ以外の芸術や技能についても、それぞれが努力して磨き上げるものである。</p>

      <p class="kobun block"><strong>兵法の道にハ、すく人まれなり</strong></p>
      <p class="genndaibun">しかし、兵法の道を極める者は少ない。</p>

      <p class="kobun block"><strong>先、武士ハ、文武二道と云て、二の道を嗜む事、是道也。</strong></p>
      <p class="genndaibun">武士とは、文武両道を修めることが本分である。</p>

      <p class="kobun block"><strong>たとひ此道不器用なりとも、武士たるものハ、己己が分才ほどは、兵の法をバ勤むべき事也。</strong></p>
      <p class="genndaibun">たとえ不得意であっても、武士である以上、自分の才能の範囲で兵法を修めるべきである。</p>

      <p class="kobun block"><strong>大かた武士の思ふ心をはかるに、武士ハたゞ、死ると云道を嗜む事と覚ゆるほどの儀也。</strong></p>
      <p class="genndaibun">多くの武士の考えを見れば、彼らはただ「死ぬこと」が武士の道だと思っているように見える。</p>

      <p class="kobun block"><strong>出家にても女にても、百姓以下に至迄、義理をしり、恥をおもひ、</strong></p>
      <p class="genndaibun">しかし、僧侶であれ、女性であれ、庶民であれ、義理を知り、恥を知ることは同じである。</p>

      <p class="kobun block"><strong>死する所を思ひきる事は、其差別なきもの也。</strong></p>
      <p class="genndaibun">死を覚悟することにおいて、そこに違いはない。</p>

      <p class="kobun block"><strong>武士の兵法をおこなふ道ハ、何事におゐても、人にすぐるゝ所を本とし、</strong></p>
      <p class="genndaibun">武士が兵法を修める道は、どのような場面でも人に優れることを基本とする。</p>

      <p class="kobun block"><strong>或ハ一身の切合に勝、或ハ数人の戦に勝、</strong></p>
      <p class="genndaibun">一対一の戦いに勝つこともあれば、集団戦に勝つこともある。</p>

      <p class="kobun block"><strong>主君のため我身のため、名をあげ身をもたてんとおもふ、これ兵法の徳を以てなり。</strong></p>
      <p class="genndaibun">主君のため、また自分自身のために名を挙げ、身を立てようとするのが、兵法の徳である。</p>

      <p class="kobun block"><strong>又、世の間に、兵法の道を習ても、實のとき、役にハ立まじきとおもふ心あるべし。</strong></p>
      <p class="genndaibun">しかし、兵法を学んでも実戦では役に立たないと思う者もいるかもしれない。</p>

      <p class="kobun block"><strong>其儀におゐては、</strong></p>
      <p class="genndaibun">そのような考えに対しては、</p>

      <p class="kobun block"><strong>何時にても役に立様に稽古し、万事に至り、役に立様におしゆる事、</strong></p>
      <p class="genndaibun">常に実戦で役立つように稽古し、あらゆる場面で役に立つようにするべきである。</p>

      <p class="kobun block"><strong>是兵法の実の道也。</strong></p>
      <p class="genndaibun">これこそが兵法の真の道である。</p>
    </div>
    <div class="page right">
      <div class="video"><div class = "video-container"><iframe  src="https://www.youtube.com/embed/S1l5LbpDWQU" frameborder="0" allowfullscreen></iframe></div></div>
      <h2>地之卷-序言</h2>
      <p class="kobun block"><strong>夫兵法者，武家之法也。</strong></p>
      <p class="genndaibun">兵法，是武士的规矩和法则。</p>

      <p class="kobun block"><strong>凡为将者，尤当遵此法</strong></p>
      <p class="genndaibun">作为将领的人，尤其需要实践这套法则</p>

      <p class="kobun block"><strong>即为士卒者，亦当识此道也</strong></p>
      <p class="genndaibun">即便是普通士兵，也应当了解这门道理</p>

      <p class="kobun block"><strong>然当今世间，深明兵法之道者，无有其人。</strong></p>
      <p class="genndaibun">然而，如今的世道中，几乎没有真正掌握兵法之道的武士</p>

      <p class="kobun block"><strong>夫世间之道有显而行者，若佛法则为救人之道</strong></p>
      <p class="genndaibun">世上有很多显而易见的道理，比如佛法是救助他人的道理</p>

      <p class="kobun block"><strong>儒道则为正文章之道，医者则为治诸病之道。</strong></p>
      <p class="genndaibun">儒道是规范文章和学问的道理，医生的道理是治病救人的方法</p>
      
      <p class="kobun block"><strong>又或歌道者授和歌之道，或数寄者、弓术者，</strong></p>
      <p class="genndaibun">还有教授和歌的歌道者、修习茶道的数寄者、精通弓术的弓术者，</p>
      
      <p class="kobun block"><strong>及诸艺诸能之道，皆各随其志，精勤修习，深致其心。</strong></p>
      <p class="genndaibun">以及其他各类技艺和才能的道理，大家都会按照自己的兴趣去勤学苦练，专注其中。</p>
      
      <p class="kobun block"><strong>唯于兵法之道者，罕有人深究焉。</strong></p>
      <p class="genndaibun">但对兵法有深刻研究的人却非常少。</p>

      <p class="kobun block"><strong>凡武士者，谓文武二道并行，乃其应循之道</strong></p>
      <p class="genndaibun">作为武士，应该做到文武兼修，这才是应走的道路</p>

      <p class="kobun block"><strong>即或此道不善者，亦当各尽其才分之所及，而勤修兵法。</strong></p>
      <p class="genndaibun">即使不擅长兵法，也要根据自己的资质和能力，尽力去修习兵法。</p>

      <p class="kobun block"><strong>夫武士之志，不过嗜「死道」而已</strong></p>
      <p class="genndaibun">总体来说，观察武士的思想，他们似乎只追求所谓的“死亡之道”</p>
      <p class="kobun block"><strong></strong></p>
      <p class="genndaibun"></p>

      <p class="kobun block"><strong>然而，死道之义，非独武士之事也</strong></p>
      <p class="genndaibun">然而，实际上，“死亡之道”并不是武士独有的。</p>

      <p class="kobun block"><strong>僧人、妇人，乃至百姓以下，皆能识义理，知廉耻，</strong></p>
      <p class="genndaibun">僧人、女人，甚至普通百姓，都可以理解道义、懂得羞耻，</p>

      <p class="kobun block"><strong>于死时决然成行者，其间无有分别。</strong></p>
      <p class="genndaibun">在面对死亡时能够下定决心去实行，这其中并没有什么职业和身份的区别。</p>

      <p class="kobun block"><strong>夫武士行兵法之道者，凡事务必超越他人。</strong></p>
      <p class="genndaibun">武士修行兵法的道路，是在任何事情上都要超越他人</p>

      <p class="kobun block"><strong>或一身斗争而胜，或众战而胜</strong></p>
      <p class="genndaibun">有时是一对一的比斗中胜利，有时是多人参与的战斗中取胜</p>

      <p class="kobun block"><strong>此为主君为己身，图扬名立身之事，乃兵法之德也。</strong></p>
      <p class="genndaibun">无论是为了主君，还是为了自己，这些胜利都是为了扬名立身，而这些正是兵法的功用所在。</p>

      <p class="kobun block"><strong>世间亦有学兵法而疑其于实战无用者</strong></p>
      <p class="genndaibun">此外，也有些人会认为，即便学习了兵法，在真正的战场上也未必能派上用场</p>

      <p class="kobun block"><strong>然于此</strong></p>
      <p class="genndaibun">对于这种情况</p>

      <p class="kobun block"><strong>当常勤修以备急用，无论何时何地，皆可施行</strong></p>
      <p class="genndaibun">随时准备好在关键时刻发挥作用。不论在任何情况下都能够应用兵法</p>

      <p class="kobun block"><strong>此乃兵法之真道也</strong></p>
      <p class="genndaibun">这才是兵法真正的意义所在</p>

        
    </div>
  </div>
</template>

<style lang="scss">
@import "./fiveRingsCss.scss";
</style>

